import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  AssetService,
  AssetType,
} from '@rd/core/services/asset-service/asset.service';
import { BannerImageConfig } from '@rd/shared-legacy/widgets/banner-image/banner-image.component';

@Component({
  selector: 'rd-star-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StarBannerComponent {
  bannerImageConfig: BannerImageConfig = {
    jpg: {
      desktop: this.assetService.getAssetPath(
        'rd-homepage-banner-desktop.jpg',
        AssetType.Image,
      ),
      mobile: this.assetService.getAssetPath(
        'rd-homepage-banner-mobile.jpg',
        AssetType.Image,
      ),
    },
    avif: {
      desktop: this.assetService.getAssetPath(
        'rd-homepage-banner-desktop.avif',
        AssetType.Image,
      ),
      mobile: this.assetService.getAssetPath(
        'rd-homepage-banner-mobile.avif',
        AssetType.Image,
      ),
    },
    webp: {
      desktop: this.assetService.getAssetPath(
        'rd-homepage-banner-desktop.webp',
        AssetType.Image,
      ),
      mobile: this.assetService.getAssetPath(
        'rd-homepage-banner-mobile.webp',
        AssetType.Image,
      ),
    },
  };

  constructor(private assetService: AssetService) {}
}
